module.exports = __webpack_public_path__ + "img/banner@2x.54f637c8.png";